/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyReportEmailsRequest
 */
export interface CompanyReportEmailsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyReportEmailsRequest
     */
    emails: Array<string>;
}

/**
 * Check if a given object implements the CompanyReportEmailsRequest interface.
 */
export function instanceOfCompanyReportEmailsRequest(value: object): value is CompanyReportEmailsRequest {
    if (!('emails' in value) || value['emails'] === undefined) return false;
    return true;
}

export function CompanyReportEmailsRequestFromJSON(json: any): CompanyReportEmailsRequest {
    return CompanyReportEmailsRequestFromJSONTyped(json, false);
}

export function CompanyReportEmailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyReportEmailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'emails': json['emails'],
    };
}

export function CompanyReportEmailsRequestToJSON(json: any): CompanyReportEmailsRequest {
    return CompanyReportEmailsRequestToJSONTyped(json, false);
}

export function CompanyReportEmailsRequestToJSONTyped(value?: CompanyReportEmailsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emails': value['emails'],
    };
}

